<div class="tw-flex tw-justify-between">
    <h1 mat-dialog-title>
        {{ 'ECMR.ecmr_editor.save_warning_dialog.title' | translate }}
    </h1>

    <button
        mat-icon-button
        mat-dialog-close>
        <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <p>{{ 'ECMR.ecmr_editor.save_warning_dialog.message' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <div class="tw-flex tw-gap-2">
        <button
            mat-raised-button
            (click)="onCloseWithoutSaving()">
            {{ 'ECMR.ecmr_editor.save_warning_dialog.close' | translate }}
        </button>
        <button
            mat-raised-button
            color="primary"
            (click)="onSaveAndExit()">
            {{
                'ECMR.ecmr_editor.save_warning_dialog.save_and_exit' | translate
            }}
        </button>
    </div>
</mat-dialog-actions>
